import Swiper from 'swiper';

export default (element) => {
  const initSwiper = () => {
    const slider = element.querySelector('.swiper');
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 23,
      slidesPerGroup: 3,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1024: {
          spaceBetween: 0,
          slidesPerView: 'auto'
        }
      },
    });
  };

  const init = () => {
    if (element.querySelectorAll('.swiper-slide').length > 3) {
      initSwiper();
    }
  };

  init();
};
